import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Info } from "lucide-react";

interface Scanner {
  name: string;
  baseUrl: string;
  icon?: string;
}

interface ScannerSelectorProps {
  value: string;
  onValueChange: (value: string) => void;
  scanners: Scanner[];
}

export function ScannerSelector({
  value,
  onValueChange,
  scanners,
}: ScannerSelectorProps) {
  return (
    <div className="flex items-center gap-2">
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger className="h-12 w-[140px] bg-gradient-to-r from-[#ffffff]/5 to-[#ffffff]/[0.07] hover:from-[#ffffff]/[0.07] hover:to-[#ffffff]/[0.09] border-[#ffffff]/10 text-[#ffffff]/70 text-sm transition-all duration-200">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-[#111111] border-[#ffffff]/10 text-white">
          {scanners.map((scanner) => (
            <SelectItem
              key={scanner.name}
              value={scanner.name}
              className="text-white hover:bg-[#ffffff]/5 cursor-pointer text-sm"
            >
              {scanner.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <button className="h-8 w-8 p-0 hover:bg-[#ffffff]/10 transition-colors rounded-md">
              <Info className="h-4 w-4 text-[#ffffff]/50" />
              <span className="sr-only">Scanner information</span>
            </button>
          </TooltipTrigger>
          <TooltipContent
            side="right"
            className="bg-[#111111] border-[#ffffff]/10"
          >
            <p className="text-xs text-white">
              Select your preferred blockchain explorer
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
